import { render, staticRenderFns } from "./ExpandedButtons.vue?vue&type=template&id=90567b60&scoped=true&"
import script from "./ExpandedButtons.vue?vue&type=script&lang=js&"
export * from "./ExpandedButtons.vue?vue&type=script&lang=js&"
import style0 from "./ExpandedButtons.vue?vue&type=style&index=0&id=90567b60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90567b60",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Resize from 'vuetify/lib/directives/resize'
installDirectives(component, {Resize})
